export default "__VITE_ASSET__DTqUsmU1__"